import { IGetIssueTypesResponse } from "./services";

export const issueTypesDataAdapter = (
  dataIssueTypes: IGetIssueTypesResponse["data"],
) => {
  return {
    items: dataIssueTypes.items.map((issueType) => ({
      ...issueType,
      ...issueType.meta,
    })),
    count: dataIssueTypes.count,
  };
};

export const createIssueDataAdapter = (data: any) => {
  const form = new FormData();

  data?.attachments?.forEach((attachment: File) => {
    form.append(`attachments`, attachment);
  });
  debugger;
  form.set("email", data.email);
  form.set("name", data.name);
  form.set("phone", data.phone);
  form.set("issueTypeId", data.issueType.id);
  form.set("locationId", data.location.value);
  form.set("customerId", data.customerId);
  if (data.sublocation?.value) {
    form.set("sublocationId", data.sublocation.value);
  }
  form.set("adminId", data.adminId);
  form.set("description", data.description);
  form.set("shouldSendNotifications", data.shouldSendNotifications);

  return form;
};
